import { forAreaRugs } from '../forAreaRugs';
import { MeasurementGuideContent } from './MeasurementGuideContent';

export const MeasurementGuideDesktop = forAreaRugs(MeasurementGuideContent);

MeasurementGuideDesktop.displayName = 'MeasurementGuideDesktop';